import React from 'react';

import { TextField } from "@king-ict/eupisi-ui/components";

import styles from "./StaticField.module.scss";

type StaticFieldParams = {
  label: string
  value?: string | number
  newValue?: string | number
  className?: string
}

export default function StaticField({ label, value, newValue, className }: StaticFieldParams): JSX.Element {
  value = value || "--";

  if (newValue !== undefined && newValue !== null && newValue.toString().toLowerCase().trim() !== value?.toString().toLowerCase().trim()) {
    return (
      <div>
        <TextField
          plaintext
          label={label}
          readonly
          value={value}
          className={styles.textFieldLabel}
        />
        <div className={className ? className : styles.newValueText}>
          {newValue}
        </div>
      </div>
    );
  }

  return (
    <div>
      <TextField
        plaintext
        label={label}
        readonly
        value={value}
        className={styles.textFieldLabel}
      />
    </div>
  );
}